module.exports = __webpack_public_path__ + "img/logo_bg.2299a0f4.png";